var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column engage-app-window h-100"},[_c('div',{staticClass:"row justify-content-center h-100"},[_c('div',{staticClass:"col-md-10 h-100"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }